import { useRefundableActions, useChangeEventArgs } from "protect-group-pulse-react";
import { useEffect, useRef } from "react";
import { useRecoilState } from "recoil";
import { protectionState } from "../events/recoils";

export default function useUpdateQuoteData(
    bookingCostPerPassenger,
    numberOfTickets,
    eventDate,
    departureAirportCode,
    arrivalAirportCode
) {
    const { updateQuoteData } = useRefundableActions();
    const [refundState, setRefundState] = useRecoilState(protectionState);
    const eventArgs = useChangeEventArgs();

    const prevArgsRef = useRef(null);

    useEffect(() => {
        if (!eventArgs) {
            return;
        }

        const prev = prevArgsRef.current;

        console.log("eventArgs", eventArgs);
        const bookingCost = bookingCostPerPassenger * numberOfTickets;
        const protectionSelected = eventArgs.productValue || 0 > 0;

        const hasChanged =
            !prev ||
            prev.formattedTotalValue !== eventArgs.formattedTotalValue ||
            prev.formattedProductValue !== eventArgs.formattedProductValue;

        if (hasChanged) {
            setRefundState((prevState) => ({
                ...prevState,
                protectionSelected: protectionSelected,
                totalValue: eventArgs.formattedTotalValue,
                bookingCost,
                protectionValue: eventArgs.formattedProductValue,
                eventDate,
                products: eventArgs.products || []
            }));

            prevArgsRef.current = eventArgs;
        }
    }, [eventArgs, bookingCostPerPassenger, numberOfTickets, eventDate]);

    useEffect(() => {
        updateQuoteData({
            totalValue: bookingCostPerPassenger * numberOfTickets,
            numberOfTickets,
            eventTravelDateTime: eventDate,
            departureAirportCode,
            arrivalAirportCode,
        });
    }, []);

    return {
        refundState,
    };
}
